import { atom } from "jotai";
import { atomWithDefault } from "jotai/utils";

export interface FormsTerminology {
  singular: string;
  plural: string;
  singularLower: string;
  pluralLower: string;
  byZapier: string;
}

export interface Toggles {
  view_only_downtime: boolean;
  show_whats_new_alert: {
    isOn: boolean;
    config: {
      message: string;
      buttonText: string;
      buttonUrl: string;
      imageUrl: string;
      imageAltText: string;
    };
  };
  blocked_domains: {
    isOn: boolean;
    config: {
      domains: string[];
    };
  };
  /**
   * 🔒 PERMANENT FLAG - DO NOT DELETE
   * Controls which embed domains are trusted with allow-same-origin.
   * This is a security configuration, not a feature rollout.
   *
   * Trusted domains can access parent page via allow-same-origin.
   * Untrusted domains get sandboxed without same-origin access.
   */
  trusted_embed_domains: {
    isOn: boolean;
    config: {
      domains: string[];
    };
  };
}

export const defaultToggles: Toggles = {
  view_only_downtime: false,
  show_whats_new_alert: {
    isOn: false,
    config: {
      message: "",
      buttonText: "",
      buttonUrl: "",
      imageUrl: "",
      imageAltText: "",
    },
  },
  blocked_domains: {
    isOn: false,
    config: {
      domains: [],
    },
  },
  trusted_embed_domains: {
    isOn: false,
    config: {
      domains: [],
    },
  },
};

/* Only to be used by the CanvasHydrator, not in the UI */
export const togglesAtom = atom<Toggles>(defaultToggles);

togglesAtom.debugLabel = "togglesAtom";

/* Use this atom in the UI since we need to be able to reset it to the state set by CanvasHydrator in DevTools */
export const togglesAtomResettable = atomWithDefault((get) => get(togglesAtom));

togglesAtomResettable.debugLabel = "togglesAtomResettable";

/**
 * Atom for the Forms terminology (formerly Interfaces).
 *
 * The rebrand from "Interfaces" to "Forms" has been fully rolled out.
 * This atom provides consistent terminology across the application.
 */
export const formsTerminologyAtom = atom((): FormsTerminology => {
  return {
    singular: "Form",
    plural: "Forms",
    singularLower: "form",
    pluralLower: "forms",
    byZapier: "Forms by Zapier",
  };
});

formsTerminologyAtom.debugLabel = "formsTerminologyAtom";

export type FormsTerminologyAtomValue = FormsTerminology;
